var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolbarTextbook2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#090101",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 91.268 91.268",
    xmlSpace: "preserve",
    stroke: "#090101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79.65,18.055l-3.908-7.559l3.68-6.993c0.393-0.739,0.364-1.632-0.068-2.349C78.922,0.437,78.145,0,77.309,0H13.762 c-1.318,0-2.389,1.07-2.389,2.39l0.058,88.878h24.94h7.546h16.078h19.894V71.375l0.006-52.737 C79.848,18.436,79.745,18.239,79.65,18.055z M22.908,84.447H19.38v-59.59h3.528V84.447z M68.93,42.94h-5.631v-2.847 c0-0.95-0.507-1.392-1.391-1.392h-8.984v33.782h5.432v5.44h-5.432h-6.326h-5.432v-5.44h5.432V38.701h-8.982 c-0.886,0-1.392,0.441-1.392,1.392v2.847h-5.631v-5.883c0-2.849,0.95-3.797,3.796-3.797h30.745c2.848,0,3.797,0.948,3.797,3.797 V42.94z M16.153,18.638V4.78h57.195L70.93,9.374c-0.363,0.691-0.365,1.517-0.007,2.211l3.646,7.053H16.153z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarTextbook2);
export default __webpack_public_path__ + "static/media/toolbar-textbook2.87e8cc8cf405357d7b98844b55157a6b.svg";
export { ForwardRef as ReactComponent };